module.exports = __webpack_public_path__ + "img/icon_version_header.3a54d5ba.png";